export type SiteNavItem = {
  id: string;
  label: string;
  to: string;
  /** 仅登录后显示。 */
  auth?: boolean;
};

export const siteNav: SiteNavItem[] = [
  { id: "explore", label: "探索", to: "/" },
  { id: "library", label: "素材库", to: "/library" },
  { id: "community", label: "社区", to: "/community" },
  { id: "workbench", label: "个人工作台", to: "/workbench", auth: true },
];

export function isNavActive(item: SiteNavItem, pathname: string) {
  if (item.id === "workbench") return pathname.startsWith("/workbench") || pathname.startsWith("/moodboard");
  if (item.to === "/") return pathname === "/";
  return pathname.startsWith(item.to);
}
